import { FloatingLabelInput } from '@/components/ui/input';
import { useForm } from '@tanstack/react-form';
import { Button } from '@/components/ui/button';
import { FieldError } from '../ui/form-field-error';
import { hasFieldErrors } from '@/utils/forms';
import { z } from 'zod';
import { getGlobalStore } from '@/utils/store';

const EmailSchema = z.object({
  email: z.string().email('Invalid email address'),
});

const EmailForm = () => {
  const { setAuthFlowEmail, setAuthFlowCurrentStep } = getGlobalStore();
  const form = useForm({
    defaultValues: {
      email: '',
    },
    validators: {
      onChange: EmailSchema,
    },
    onSubmit: async ({ value }) => {
      await new Promise((resolve) => setTimeout(resolve, 400));
      setAuthFlowEmail(value.email);
      setAuthFlowCurrentStep('postcode');
    },
  });
  return (
    <div className="flex flex-col gap-6 text-grey-900">
      <p className="text-xl font-nunito700">Login details</p>
      <p className="text-base">Sign in with your registered email.</p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          form.handleSubmit();
        }}
        className="space-y-6"
      >
        <form.Field name="email">
          {(field) => (
            <div className="flex flex-col gap-1">
              <FloatingLabelInput
                name="email"
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
                label="Email"
                size="large"
                hasError={hasFieldErrors(field)}
              />
              <FieldError field={field} />
            </div>
          )}
        </form.Field>
        <form.Subscribe
          selector={(state) => [state.canSubmit, state.isSubmitting]}
          children={([canSubmit, isSubmitting]) => (
            <Button
              loading={isSubmitting}
              variant="primary"
              type="submit"
              size="medium"
              disabled={!canSubmit}
              className="flex-none"
            >
              Next
            </Button>
          )}
        />
      </form>
    </div>
  );
};
export { EmailForm };
